import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rdf-table-row-controls',
  templateUrl: './table-row-controls.component.html',
  styleUrls: ['./table-row-controls.component.css']
})
export class TableRowControlsComponent implements OnInit {
  @Input() column
  @Input() emittables
  @Output() onEditColumn = new EventEmitter<any>();
  @Output() onDeleteColumn = new EventEmitter<any>();
  showInputs = false
  constructor() { }

  ngOnInit() {
  }

  editingColumn() {
    this.onEditColumn.emit()
  }
  deleteColumn() {
    this.onEditColumn.emit()
  }

}
